import axios from 'axios';
import {backendHost} from '../../config';

export const getOffersById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/offer/${params.id}`);
};